import { render, staticRenderFns } from "./NextRaceView.vue?vue&type=template&id=810e5ffc&scoped=true"
import script from "./NextRaceView.vue?vue&type=script&lang=js"
export * from "./NextRaceView.vue?vue&type=script&lang=js"
import style0 from "./NextRaceView.vue?vue&type=style&index=0&id=810e5ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e5ffc",
  null
  
)

export default component.exports